import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { MessageSquareIcon, UserIcon, ClockIcon } from 'lucide-react';
const SolutionOverview = () => {
  return <section className="py-16 bg-cream" data-id="element-367">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-368">
        <div className="md:grid md:grid-cols-2 md:gap-12 items-center" data-id="element-369">
          <div data-id="element-370">
            <h2 className="text-3xl md:text-4xl font-bold font-display text-charcoal" data-id="element-371">
              Meet Your Digital Sous Chef
            </h2>
            <p className="mt-4 text-lg text-sage" data-id="element-372">
              ChefChat handles your restaurant's digital communication with the
              same care and attention you give to your signature dishes.
            </p>
            <div className="mt-8 space-y-6" data-id="element-373">
              <div className="flex" data-id="element-374">
                <div className="flex-shrink-0" data-id="element-375">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-burgundy text-white" data-id="element-376">
                    <MessageSquareIcon size={24} data-id="element-377" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-378">
                  <h3 className="text-xl font-medium text-charcoal" data-id="element-379">
                    Authentic Communication
                  </h3>
                  <p className="mt-2 text-sage" data-id="element-380">
                    ChefChat learns your unique voice and communication style to
                    maintain authentic interactions with your customers.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-381">
                <div className="flex-shrink-0" data-id="element-382">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-burgundy text-white" data-id="element-383">
                    <ClockIcon size={24} data-id="element-384" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-385">
                  <h3 className="text-xl font-medium text-charcoal" data-id="element-386">
                    Always Available
                  </h3>
                  <p className="mt-2 text-sage" data-id="element-387">
                    Never miss another reservation request or inquiry, even
                    during your busiest service hours.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-388">
                <div className="flex-shrink-0" data-id="element-389">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-burgundy text-white" data-id="element-390">
                    <UserIcon size={24} data-id="element-391" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-392">
                  <h3 className="text-xl font-medium text-charcoal" data-id="element-393">
                    Restaurant-Specific Intelligence
                  </h3>
                  <p className="mt-2 text-sage" data-id="element-394">
                    Built specifically for restaurants, ChefChat understands
                    menu questions, dietary restrictions, and hospitality
                    nuances.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-8" data-id="element-395">
              <Link to="/signup" className="inline-flex justify-center items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-burgundy hover:bg-burgundy/90 transition-colors" data-id="element-396">
                Start Your Free Trial
              </Link>
            </div>
          </div>
          <div className="mt-10 md:mt-0" data-id="element-397">
            <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-398">
              <div className="p-4 bg-burgundy text-white" data-id="element-399">
                <h3 className="text-lg font-medium" data-id="element-400">ChefChat Dashboard</h3>
              </div>
              <div className="p-6" data-id="element-401">
                <div className="mb-6" data-id="element-402">
                  <div className="flex justify-between items-center mb-2" data-id="element-403">
                    <h4 className="font-medium text-charcoal" data-id="element-404">
                      Today's Activity
                    </h4>
                    <span className="text-sm text-sage" data-id="element-405">May 15, 2023</span>
                  </div>
                  <div className="grid grid-cols-3 gap-4 text-center" data-id="element-406">
                    <div className="bg-cream p-3 rounded-lg" data-id="element-407">
                      <p className="text-2xl font-bold text-burgundy" data-id="element-408">24</p>
                      <p className="text-xs text-sage" data-id="element-409">Messages</p>
                    </div>
                    <div className="bg-cream p-3 rounded-lg" data-id="element-410">
                      <p className="text-2xl font-bold text-burgundy" data-id="element-411">8</p>
                      <p className="text-xs text-sage" data-id="element-412">Reservations</p>
                    </div>
                    <div className="bg-cream p-3 rounded-lg" data-id="element-413">
                      <p className="text-2xl font-bold text-burgundy" data-id="element-414">3</p>
                      <p className="text-xs text-sage" data-id="element-415">Reviews</p>
                    </div>
                  </div>
                </div>
                <div data-id="element-416">
                  <h4 className="font-medium text-charcoal mb-3" data-id="element-417">
                    Recent Conversations
                  </h4>
                  <div className="space-y-3" data-id="element-418">
                    <div className="p-3 bg-cream rounded-lg" data-id="element-419">
                      <div className="flex justify-between" data-id="element-420">
                        <span className="text-sm font-medium text-charcoal" data-id="element-421">
                          Siti N.
                        </span>
                        <span className="text-xs text-sage" data-id="element-422">10:23 AM</span>
                      </div>
                      <p className="text-sm mt-1" data-id="element-423">
                        Do you have any gluten-free options?
                      </p>
                      <p className="text-xs text-success mt-1" data-id="element-424">
                        ✓ Handled by ChefChat
                      </p>
                    </div>
                    <div className="p-3 bg-cream rounded-lg" data-id="element-425">
                      <div className="flex justify-between" data-id="element-426">
                        <span className="text-sm font-medium text-charcoal" data-id="element-427">
                          Rajesh M.
                        </span>
                        <span className="text-xs text-sage" data-id="element-428">9:15 AM</span>
                      </div>
                      <p className="text-sm mt-1" data-id="element-429">
                        Can I make a reservation for 6 people tomorrow at 7pm?
                      </p>
                      <p className="text-xs text-success mt-1" data-id="element-430">
                        ✓ Handled by ChefChat
                      </p>
                    </div>
                    <div className="p-3 bg-cream rounded-lg" data-id="element-431">
                      <div className="flex justify-between" data-id="element-432">
                        <span className="text-sm font-medium text-charcoal" data-id="element-433">
                          Nurul H.
                        </span>
                        <span className="text-xs text-sage" data-id="element-434">Yesterday</span>
                      </div>
                      <p className="text-sm mt-1" data-id="element-435">
                        What time do you close on Sundays?
                      </p>
                      <p className="text-xs text-success mt-1" data-id="element-436">
                        ✓ Handled by ChefChat
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SolutionOverview;